import * as React from 'react'
import ItineraryModel from '../../models/ItineraryModel'
import { Buttons, FormFieldWrapper, Popup, Tooltip, indexDown, indexUp } from 'traveldesk-ui'
import { useSelector } from 'react-redux'
import { ApplicationState } from '../../store'
interface Props {
    tourId: number
    itineraries: ItineraryModel[]
    onStartAddEditItinerary: (itinerary: ItineraryModel) => void
    onChange: (itineraries: ItineraryModel[]) => void
}
const TourItineraryManager = (props: Props) => {
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)
    const onAddItenerary = () => {
        const newItenerary = new ItineraryModel(props.tourId, props.itineraries.length + 1)
        props.onStartAddEditItinerary(newItenerary)
    }
    const onEditItenerary = (id: number, guid: string) => {
        const itinerary = props.itineraries.find(x => (id && x.id == id) || (guid && x.guid == guid))
        if (itinerary)
            props.onStartAddEditItinerary(itinerary)
    }
    const onDeleteItinerary = (id: number, guid: string) => {
        props.onChange(props.itineraries
            .filter(x => (!id || x.id != id) && (!guid || x.guid != guid))
            .map((x, index) => {
                x.index = index + 1
                return x
            }))
    }
    const onItineraryUp = (index: number) => {
        const newItinerary = indexUp(props.itineraries, index)
        props.onChange(newItinerary)
    }
    const onItineraryDown = (index: number) => {
        const newItinerary = indexDown(props.itineraries, index)
        props.onChange(newItinerary)
    }


    return <FormFieldWrapper>

        <Tooltip text={Localization.getString('Add itinerary')}>
            <Buttons.ButtonSmallGreen onClick={onAddItenerary}>
                <i className="fa fa-plus" />
            </Buttons.ButtonSmallGreen>
        </Tooltip>
        <br />
        <br />
        {props.itineraries.map((itinerary, i) => {
            return <FormFieldWrapper key={itinerary.index + itinerary.id + itinerary.guid}>
                <label>Itinerary #{itinerary.index}: {itinerary.name} ({itinerary.stops.length} stops)
                    <i className='fa fa-trash float-right clickable' onClick={() => onDeleteItinerary(itinerary.id, itinerary.guid)} />
                    <i className='fa fa-pencil float-right clickable' onClick={() => onEditItenerary(itinerary.id, itinerary.guid)} />
                    {i > 0 && <i className='fa fa-arrow-up float-right clickable' onClick={() => onItineraryUp(itinerary.index)} />}
                    {i < props.itineraries.length - 1 && <i className='fa fa-arrow-down float-right clickable' onClick={() => onItineraryDown(itinerary.index)} />}

                </label>
                <ul>
                    {itinerary.stops.map(stop => <li key={`stop-${stop.index}-${stop.guid}-${stop.name}`}>#{stop.index}: {stop.name}</li>)}
                </ul>

            </FormFieldWrapper>
        })}
    </FormFieldWrapper>
}
export default TourItineraryManager